<template>
    <Layout :pagetitle="'單位組織與使用系統對應'">
       
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title mb-0">組織基本資訊</h4>
                        </div>
                        <div class="card-body">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="mb-3">
                                                <label class="form-label" for="organ-no"><span
                                                    style="color:red">*</span>統一編號/組織編號</label>
                                                <div>
                                                    <span> {{ form.id }}</span>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="mb-3">
                                                <label class="form-label" for="organName"><span
                                                    style="color:red">*</span>組織名稱</label>
                                                    <div>
                                                    <span> {{ form.name }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                    <div class="col-md-4">
                                        <button type="submit" @click.prevent="assign" :disabled="isCloseBtn"
                                                class="btn btn-primary">
                                            設定組織與系統對應
                                        </button>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-log-12">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title mb-0">當前綁定之系統清單</h4>
                        </div>
                        <div class="card-body">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <div class="row">
                                        <Grid :style="{ height: '100%' }"
                                              :data-items="ownGrid.result"
                                              :selected-field="ownGrid.selectedField"
                                              :sortable="true"
                                              :pageable="{ refresh: true, pageSizes: [10, 25, 50, 100], buttonCount: 5 }"
                                              :scrollable="'none'"
                                              :filterable="false"
                                              :filter="ownGrid.filter"
                                              :sort="ownGrid.sort"
                                              :skip="ownGrid.skip"
                                              :take="ownGrid.take"
                                              :total="ownGrid.total"
                                              :columns="columns"
                                              @selectionchange="onSelectionChange"
                                              @headerselectionchange="onHeaderSelectionChange"
                                              @rowclick="onRowClick"
                                              @pagechange="pageChangeHandler">
                                        </Grid>
                                    </div>
                                    
                                </div>
                                
                            </div>
                           
                        </div>
                        <div class="card-body"> 
                            <div class="row">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <button type="submit" @click.prevent="removeSystem" :disabled="isCloseBtn"
                                            class="btn btn-danger">移除綁定系統
                                    </button>
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>

                </div>
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <div class="row d-flex justify-content-between">

                                        <div class="hstack gap-3">
                                            <button type="submit" @click.prevent="back" :disabled="isCloseBtn"
                                                    class="btn btn-primary">取消
                                            </button>
                                            <div class="vr"></div>
                                            <button type="submit" :disabled="isCloseBtn" class="btn btn-primary">
                                                儲存
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

    </Layout>
</template>

<script>
import {useRoute} from 'vue-router';
import Layout from "../../layouts/main";
import {onMounted, ref} from "vue";
import {Grid} from "@progress/kendo-vue-grid";
import axios from 'axios';
import {toDataSourceRequestString} from "@progress/kendo-data-query";
import "../../../components/form/custom/organ-validate";


const findOrganization = async (organId) => {
    const quer_url = '/api/FindOrganization'
            const init_data = {method: 'GET', accept: 'application/json', headers: {}};
            let organ = await fetch(`${quer_url}?code=${organId}`, init_data)
                .then(response => response.json());

    return {organCode: organ.value.organCode, name: organ.value.name}
}

const fetchData = async (dataState) => {
    const queryStr = `${toDataSourceRequestString(dataState)}`; // Serialize the state
    const base_url = "/api/QueryOrganOwnSystem";
    const init = {method: "GET", accept: "application/json", headers: {}};
    let fetchResult = await fetch(`${base_url}?${queryStr}`, init)
        .then((response) => response.json())
        .then(({data, total}) => {
            let result = data.map((item) => {
                return {...item, selected: false};
            });
            return {result: result, total: total};
        });

    return fetchResult;
};



export default {
    setup() {
        const route = useRoute();
        const code = route.params.id;

        const form = ref({
            id: code,
            name: "",
        });
        const isCloseBtn = ref(false);


        const ownGrid = ref({
            selectedField: "selected",
            sort: null,
            filter: {
                logic: "and",
                filters: [{
                    field: "organId",
                    operator: "eq",
                    value: code,
                }],
            },
            result: [],
            skip: 0,
            take: 10,
            total: 0,
            staticColumns: [
                {field: "systemCode", title: "系統代號"},
                {field: "systemName", title: "系統名稱"},
                {field: "systemDomain", title: "系統網域"},
                {field: "systemDescription", title: "系統描述"}
            ],
            formSelected: [],
        });



        onMounted(async () => {

            let formData = await findOrganization(code);
            form.value.id = formData.organCode;
            form.value.name = formData.name;

            //fetch data
            let dataState = {skip: ownGrid.value.skip, take: ownGrid.value.take, filter: ownGrid.value.filter};
            let fetchResult = await fetchData(dataState);

            ownGrid.value.result = fetchResult.result;
            ownGrid.value.total = fetchResult.total;

        });

        return {
            ownGrid,
            form,
            isCloseBtn,
        };
    },
    components: {
        Layout, Grid
    },
    computed: {
        areAllSelected() {
            return this.ownGrid.result.findIndex((item) => item.selected === false) === -1;
        },
        columns() {
            return [
                {
                    field: "selected",
                    width: "50px",
                    headerSelectionValue: this.areAllSelected,
                },
                ...this.ownGrid.staticColumns,
            ];
        },
    },
    methods: {
        fetchData: async function (dataState) {
            let data = await fetchData(dataState);
            this.ownGrid.result = data.result;
            this.ownGrid.total = data.total;
        },
        pageChangeHandler: function (event) {
            setTimeout(() => {
                this.ownGrid.skip = event.page.skip;
                this.ownGrid.take = event.page.take;
                this.fetchData({skip: this.ownGrid.skip, take: this.ownGrid.take, filter: this.ownGrid.filter});
            }, 300);
        },
        onHeaderSelectionChange(event) {
            let checked = event.event.target.checked;
            this.ownGrid.result = this.ownGrid.result.map((item) => {
                return {...item, selected: checked};
            });
            this.ownGrid.result.forEach((element) => {
                this.changeApplyFormSelected(element.userCode, element.selected);
            });
        },
        onSelectionChange(event) {
            event.dataItem[this.ownGrid.selectedField] = !event.dataItem[this.ownGrid.selectedField];
            let systemCode = event.dataItem["systemCode"];
            this.changeApplyFormSelected(systemCode, event.dataItem[this.ownGrid.selectedField]);
        },
        onRowClick(event) {
            event.dataItem[this.ownGrid.selectedField] = !event.dataItem[this.ownGrid.selectedField];
            let systemCode = event.dataItem["systemCode"];
            this.changeApplyFormSelected(systemCode, event.dataItem[this.ownGrid.selectedField]);
        },
        changeApplyFormSelected(systemCode, isSelected) {
            if (isSelected) {
                if (!this.ownGrid.formSelected.includes(systemCode)) {
                    this.ownGrid.formSelected.push(systemCode);
                }
            } else {
                if (this.ownGrid.formSelected.includes(systemCode)) {
                    this.ownGrid.formSelected = this.ownGrid.formSelected.filter((x) => x != systemCode);
                }
            }
        },
        back() {
            this.$router.push({path: "/organization/list-organization"});
        },
        assign() {
            let organId = this.form.id;
            this.$router.push({name: 'organization-assign-system', params: {id: organId}});
        },
        removeSystem() {
            let form = {
                SystemCodes: this.ownGrid.formSelected,
                OrganId: this.form.id
            };
            axios({
                method: "post",
                url: "/api/RemoveOrganizationSystem",
                headers: {
                    "content-type": "application/json",
                },
                data: form,
            })
                .then((response) => {
                    console.log(response);
                    this.fetchData({skip: this.ownGrid.skip, take: this.ownGrid.take, filter: this.ownGrid.filter});
                })
                .catch((error) => {
                    console.log(error);
                    this.fetchData({skip: this.ownGrid.skip, take: this.ownGrid.take, filter: this.ownGrid.filter});
                });
            this.ownGrid.formSelected = [];
        }
    },
};
</script>
    